export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-path-03c33e3379c8d0adee93dcd90be7fac8.svg";